import React from "react";

const Login = () => {
  const redirectUrl = `${process.env.REACT_APP_URL}/login?redirecturl=${window.origin}/verify-login-merchant`;

  return (
    <div className="header-nav-feature header-nav-features-cart header-nav-features-cart-big d-inline-flex top-2 ms-2">
      <a href={redirectUrl} className="header-nav-features-toggle">
        My Account
      </a>
    </div>
  );
};

export default Login;
